module.exports = __webpack_public_path__ + "985f4537b3f53ca5e64146b7a6f2a364.svg";